import { render } from "./CustomPropertyList.vue?vue&type=template&id=e0931614"
import script from "./CustomPropertyList.vue?vue&type=script&lang=js"
export * from "./CustomPropertyList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__